// LoadingSpinner.tsx
// Indicateur de chargement accessible.

import { Loader2 } from 'lucide-react';

import { cn } from '@/shared/utils/cn';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

const SIZE_CLASSES = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-10 w-10',
} as const;

export function LoadingSpinner({
  size = 'md',
  label = 'Chargement en cours…',
  className,
}: LoadingSpinnerProps) {
  return (
    <div
      className={cn('flex items-center justify-center', className)}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <Loader2 className={cn('animate-spin text-primary', SIZE_CLASSES[size])} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
